import { Box, Typography } from '@mui/material';
import { HIDE_ON_PHONE, libraryRowSx } from './layout';

export default function LibraryHeader() {
  return (
    <Box sx={{ ...libraryRowSx, minHeight: 44 }}>
      <span />
      <Typography variant="body2" fontWeight={600}>
        Item
      </Typography>
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{ display: HIDE_ON_PHONE }}>
        Category
      </Typography>
      <Typography variant="body2" fontWeight={600} textAlign="right">
        Price
      </Typography>
      <span />
    </Box>
  );
}
